// extracted by mini-css-extract-plugin
export default {"totalRow":"DepartmentsTable_totalRow__j-Nmi","loader":"DepartmentsTable_loader__nr1yT"};